import { render, staticRenderFns } from "./AbkCookiesPolicy.vue?vue&type=template&id=54a7190e&scoped=true&"
import script from "./AbkCookiesPolicy.vue?vue&type=script&lang=js&"
export * from "./AbkCookiesPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AbkCookiesPolicy.vue?vue&type=style&index=0&id=54a7190e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7190e",
  null
  
)

export default component.exports